import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-remailing',
  templateUrl: './remailing.component.html',
  styleUrls: ['./remailing.component.css']
})
export class RemailingComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
